import React, { useEffect, useState } from 'react';
import { Container } from '@mui/material';
import axios from 'axios';
import './privacy.scss';

const PrivacyPolicy = () => {
    const [privacyPolicy, setPrivacyPolicy] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
        axios.get('/api/privacy-policy')
            .then((res) => {
                console.log(res.data);
                setPrivacyPolicy(res.data.content);
            });
    }, []);

    return <Container
        maxWidth="md"
        className="privacy-policy"
    >
        <div className="container">
            <div className="privacy-policy-container" dangerouslySetInnerHTML={{ __html: privacyPolicy }}></div>
        </div>
    </Container>;
};

export default PrivacyPolicy;

/*
const PrivacyPolicy = () => <Container
    maxWidth="md"
    className="privacy-policy"
>
    <div className="container">
        <div className="section page-title">
            <div className="page-title-container">
                <h1>Privacy Policy</h1>
            </div>
        </div>

        <div className="priv-content-container">
            <h3><b>Privacy Policy</b></h3>
            <div className="priv-content">
                <LazyLoadImage src={YoutubeMakeMoney} />
                <p>Last Modified:  November 2018</p>

                <p>Our services are not intended for anyone under 18. We have checks to ensure that we we do not knowingly collect personal information from anyone under 18.</p>

                <h4><b>Introduction</b></h4>
                <p>Privaposts is a social network which enables some users to share their content; other users to enjoy others’ content and for some to do both.</p>

                <p>When people use these services they share some information with us. This policy sets out the information we collect, how we use it and who we share it with.</p>
                <p>
                    We confirm that the lawful basis for processing your data is that by participating with our social network you have
                    <Link to="/terms"> contracted with us</Link>
                    {' '}
                    and the processing of data set out here is part of that contract. To the extent that we have to monitor and control use of our site the basis for that processing is to fulfil a legal obligation
                </p>

                <p><b>Below we set out our policy but please be aware that:</b></p>
                <ol>
                    <li>all content is monitored by third parties to ensure that the network is lawful and legal and not brought into disrepute;</li>
                    <li>you will not provide or give financial information to us but to our chosen partners. These  entities may or may not be located in the Australian Economic Area;</li>
                    <li>we will not transfer your person data outside the European Economic Area;</li>
                    <li>we will not profile or make automated decisions which affect you.</li>
                </ol>
                <p>Users are either “Creators” or “Followers”/ “Subscribers”. A Creator posts content for Followers to access. Creators determine the monthly subscription fee which followers pay to view the content. Followers decide what content to view.</p>

                <p>In this policy, a 'User' or 'you' refers to any Creator or Followers.</p>
                <h4><b>Information we collect</b></h4>
                <p>Regardless of whether you are a Creator orFollowers or both there are three categories of information we collect:</p>
                <ul>
                    <li>Information you choose to give us.</li>
                    <li>Information we get when you use our services.</li>
                    <li>Information we get from third parties.</li>
                </ul>
                <h4><b>Information you choose to give us</b></h4>
                <p>In order to open an account and use our services you will disclose to us:</p>
                <ol>
                    <li>Your name;</li>
                    <li>postal address;</li>
                    <li>an email address;</li>
                    <li>a username;</li>
                    <li>your date of birth;</li>
                    <li>your banking credentials</li>
                </ol>
                <p>To make it easier for others to find you, we may also ask you to provide us with some additional information that will be publicly visible on our services, such as profile pictures, a profile name or other useful identifying information.</p>

                <p>Be careful when you provide us information about you and others you know (this is likely to be personal data) which will be uploaded onto your pages of our network. Other users maybe able to use that content for their own purposes.</p>

                <p>If you have any reason to contact us separately for example to discuss concerns with customer services then we’ll collect whatever information you volunteer.</p>
                <h4><b>Information we get when you use our services</b></h4>
                <p>When you use our services, we collect information about the content you have viewed or shared. For example:</p>
                <ul>
                    <li>
                        <b>Usage information.</b>
                        {' '}
                        We collect information about the content that Viewers have accessed. From that we may highlight to that user similar content;
                    </li>
                    <li>
                        <b>Content information.</b>
                        {' '}
                        We collect content you create on our services, such as custom stickers, photos, videos, text and information about the content you create or provide, such as if the recipient has viewed the content and the metadata that is provided with the content.
                    </li>
                    <li>
                        <b>Device information.</b>
                        {' '}
                        We collect IP addresses or other identification data from and about the devices you use. For example, we collect:
                    </li>
                    <li>information about your hardware and software, such as the hardware model, operating system version, device memory, advertising identifiers, unique application identifiers, apps installed, unique device identifiers, browser type, language, battery level and time zone;</li>
                    <li>
                        <b>Location information.</b>
                        {' '}
                        When you use our services, we may collect information about your location. With your consent, we may also collect information about your precise location using methods that include GPS, wireless networks, cell towers, Wi-Fi access points and other sensors such as gyroscopes, accelerometers and compasses.
                    </li>
                    <li>
                        <b>Information collected by cookies and other technologies.</b>
                        {' '}
                        Like most online services we use cookies. The cookies we use are the usual Google analytics and session cookies
                    </li>
                    <li>(For your information: most web browsers are set to accept cookies by default. If you prefer, you can usually remove or reject browser cookies through the settings on your browser or device. Keep in mind, though, that removing or rejecting cookies could affect the availability and functionality of our services.)</li>
                    <li>
                        <b>Log information.</b>
                        {' '}
                        We also collect log information when you use our website. That information includes, among other things:
                        <ol>
                            <li>details about how you’ve used our services.</li>
                            <li>device information, such as your web browser type and language.</li>
                            <li>access times.</li>
                            <li>pages viewed.</li>
                            <li>IP address.</li>
                            <li>identifiers associated with cookies or other technologies that may uniquely identify your device or browser</li>
                        </ol>
                    </li>
                </ul>
                <h4><b>How we use information</b></h4>
                <p>We use this information to ensure that the content can be enjoyed by everyone. Our objective is to strive to keep the content appropriate, tasteful and lawful.  Here are some of the ways we do that:</p>
                <ul>
                    <li>develop, operate, improve, deliver, maintain and protect our products and services.</li>
                    <li>send you communications, including by email. For example, we may use email to respond to support enquiries or to share information about our site.</li>
                    <li>monitor and analyse trends and usage.</li>
                    <li>verify your identity and prevent fraud or other unauthorised or illegal activity.</li>
                    <li>use information we’ve collected from cookies and other technology to enhance the services and your experience with them.</li>
                    <li>enforce our Terms of Service and other usage policies.</li>
                    <li>If you breach our terms or break the law, or if we have reasons to believe you have breached our terms or are breaking the law or have broken the law, we may share your details with other users if their safety is at risk. For example if a creator has a restraining order against you and you are trying to hide behind an anonymous identity, we will work with the creator to confirm your identity to ensure the creators safety and that the law is not being broken. Another example is if you have abused or caused harm to another user then your details that you entered will be shared to protect the safety of the other user/s against you. You agree that any information you enter may be shared with other users including username, email, location, age, gender, etc.</li>
                </ul>
                <p>We may also store or use information locally on your device.</p>
                <h4><b>How we share information</b></h4>
                <p>We may share information about you in the following ways:</p>

                <p>With other Users. We may share the following information with other Users:</p>
                <ul>
                    <li>information you enter, such as your username, profile name, and profile bio.</li>
                    <li>any additional information you have consented for us to share.</li>
                    <li>content you post or send will be shared with your Fans and/or the Creators you subscribe to.</li>
                </ul>
                <p>With all Users. We may share the following information with all Users:</p>
                <ul>
                    <li>public information such as your profile name, username and profile pictures.</li>
                </ul>
                <p>With creators. By becoming a subscriber of a creator, you agree to have the following information shared with that creator.</p>
                <ul>
                    <li>As mentioned in 1) With other users, information you enter such as your username, email, location, age, gender, profile name, and profile bio.</li>
                    <li>all information about your subscription, including amount and start date, but not your full payment card information</li>
                    <li>any messages you send creators through Privaposts</li>
                    <li>your physical address, city, state, and country.</li>
                </ul>
                <p>With third parties. We may share your information with the following third parties:</p>
                <ul>
                    <li>With service providers. We may share information about you with service providers who perform services on our behalf.</li>
                    <li>
                        With third parties for legal reasons. We may share information about you if we reasonably believe that disclosing the information is needed to:
                        <br />
                        – comply with any valid legal process, governmental request, or applicable law, rule or regulation.investigate, remedy, or enforce potential Terms of Service violations.
                        <br />

                        – protect our, our users’ or others’ rights, property and safety.
                        <br />

                        – detect and resolve any fraud or security concerns.
                    </li>
                    <li>With third parties as part of a merger or acquisition. If Privaposts gets involved in a merger, asset sale, financing, liquidation or bankruptcy, or acquisition of all or some portion of our business to another company, we may share your information with that company before and after the transaction closes.</li>
                </ul>
                <h4><b>Third-party content and integrations</b></h4>
                <p>At present we do not offer these.</p>

                <h4><b>Analytics and advertising services</b></h4>
                <p>We do not let other companies collect information about how you use our services.</p>

                <h4><b>How long we keep your content</b></h4>
                <p>We want you to be in control of your information. You can delete any content when you want.</p>

            </div>
        </div>
    </div>
</Container>;

export default PrivacyPolicy;
*/